export const bookList = [{
    shId: 'gJ9Rg',
    cover: 'http://imgb2.chineseall.cn/bookcover/553/492/367/61412762_st_300_400.jpg',
    name: '神奇教室（浙江篇）——龙舟划进课本',
    author: '梅瑜著',
    intro: '“神奇教室”系列以幻想、逗趣又惊奇的历险故事为主线，讲述了华优优老师带领103班的淘气包们搭乘飞转自如的神奇教室，去祖国各地探秘中国传统文化，开启不可思议的时空大冒险。《龙舟划进了课本》一书坐标浙江。江南龙舟赛缺一支参赛队伍，灵隐寺的济公爷爷寄来一封“紧急邮件”，想要103班的孩子们赶去帮忙。孩子们跃跃欲试又惴惴不安，因为他们没有一个人会划龙舟。华优优老师告诉大家，济公爷爷随信还寄来了一张路线图，只要在路线图上标注的每个地方找到一块拼图，拼出的最后图案，就可以知晓龙舟赛获胜的秘籍。于是，一场寻找拼图的神奇之旅又开始了。103班的孩子们划着泡泡龙舟，来到远古的河姆渡时期，遇到了原始人；赶到水乡绍兴，在鸬鹚阿通的带领下拜访闰土的西瓜地；在王羲之的“鹅池”，淘气包们差点被大白鹅驱赶出境……名人胜景轮番出现，精彩故事不断上演。',
    url: '/v3/book/detail/gJ9Rg',
    wUrl: '/book/detail/gJ9Rg/cover'
  },

  {
    shId: 'Wvscg',
    cover: 'http://imgb2.chineseall.cn/bookcover/853/606/605/61382155_st_300_400.jpg',
    name: '东江谣',
    author: '谢莲秀, 香杰新著',
    intro: '《东江谣》是一部现实题材长篇儿童小说。作品以古老绵延的东莞东江以及沿岸的村庄为背景，从少年儿童的视角，写主人公辉仔及其生活的乡村与非物质文化遗产——龙舟之间的动人故事。小说着重讲述了一群乡村儿童与龙舟的结缘，在描绘他们的成长历程的同时，潜移默化地引导小读者认识与思考传统文化在现代社会的传承问题，并弘扬了龙舟精神及大湾区文化，描绘出一幅清新质朴、岭南特色浓郁的田园风景画卷。',
    url: '/v3/book/detail/Wvscg',
    wUrl: '/book/detail/Wvscg/cover'
  },
  {
    shId: '9JB3g',
    cover: 'http://imgb2.chineseall.cn/bookcover/246/732/907/61338677_st_300_400_1.jpg',
    name: '南海龙舟',
    author: '何洪伟主编',
    intro: '赛龙舟是中国端午节的习俗之一，也是国家级非物质文化遗产。南海是具有深厚历史文化的名城，是中国著名的龙舟和狮子文化之城。龙舟文化是南海文化的一张靓丽名片，南海龙舟享誉海内外。本书从龙舟的起源与历史、龙舟类型、赛龙舟起源传说、龙舟文化与民俗、龙舟的题材与特点、赛龙舟的艺术与审美、龙舟的制作与竞渡、龙舟的流派（产地）与风格、龙舟的传承与传人、龙舟竞赛规则等方面，全面展示南海的龙舟特色和历年龙舟比赛所取得的成果。',
    url: '/v3/book/detail/9JB3g',
    wUrl: '/book/detail/9JB3g/cover'
  },
  {
    shId: 'CiN6j',
    cover: 'http://imgb2.chineseall.cn/bookcover/486/330/933/61232238_st_300_400_1.jpg',
    name: '虎头将军',
    author: '旭爽文',
    intro: '小米和金蟾在爷爷家过端午节，金蟾有幸扮演了一次“虎头将军”，却为此被小米嘲笑了一番。端午节好热闹，爷爷带着他们去河里比赛抢鸭子。在比赛时，两条船不小心闯进了传说中住着蛇妖的芦苇荡，一时间风雷大作，波浪滔天……难道蛇妖真的存在吗？两条船上的人们互相救助，身为“虎头将军”的金蟾当然也没闲着。它到底有什么妙计呢？',
    url: '/v3/book/detail/CiN6j',
    wUrl: '/book/detail/CiN6j/cover'
  },
  {
    shId: 'NuM6j',
    cover: 'http://imgb2.chineseall.cn/bookcover/283/127/730/61232035_st_300_400_1.jpg',
    name: '伊伊，端午节快乐！',
    author: '丁丁著',
    intro: '《伊伊，端午节快乐！》是“跟着伊伊过大节·中国民俗节日系列绘本”中的第二部作品，为原创绘本。端午节快到了，奶奶告诉伊伊“五月五，庆端午，划龙舟，敲锣鼓。龙王掌管降雨，龙舟赛就是祭拜龙神、祈祷风调雨顺、国泰民安的一种形式。”伊伊想，“他那么神通广大，应该可以解答我的所有问题吧？”五天五件事，每晚伊伊都把自己困惑的问题留给龙王来“指点迷经”。这五件事包括家里的活动、学校的活动以及陪爸爸去参加龙舟赛。直到故事末尾，才点出每天“聆听”伊伊故事和问题并给出参考答案的就是爸爸——最爱伊伊的那个龙王。',
    url: '/v3/book/detail/NuM6j',
    wUrl: '/book/detail/NuM6j/cover'
  },
  {
    shId: 'MGp8g',
    cover: 'http://imgb2.chineseall.cn/bookcover/775/511/191/61214581_st_300_400_1.jpg',
    name: '端午节与龙舟文化读本',
    author: '胡元斌主编',
    intro: '本书包括端午起源、习俗流布、粽子相关食材的历代变迁、风格迥异的节日饮食习俗、具有深厚内涵的龙舟文化等内容。',
    url: '/v3/book/detail/MGp8g',
    wUrl: '/book/detail/MGp8g/cover'
  },
  {
    shId: '32ZXg',
    cover: 'http://imgb2.chineseall.cn/bookcover/920/560/304/61198774_st_300_400_1.jpg',
    name: '让孩子懂得生活的节日故事',
    author: '潘志辉编绘',
    intro: '除夕吃饺子、放烟花，大年初一拜年、领红包，元宵节看花灯，端午节赛龙舟、吃粽子，中秋节赏月、吃月饼……每个节日都有属于自己的故事、风俗以及吃食。由此，孩子们将体味生活的美好，然后爱上生活，并积极快乐地去生活。',
    url: '/v3/book/detail/32ZXg',
    wUrl: '/book/detail/32ZXg/cover'
  },
  {
    shId: 'NEEUg',
    cover: 'http://imgb2.chineseall.cn/bookcover/926/501/953/61023308_st_1.jpg',
    name: '中国传统节日故事绘本游戏书——端午节',
    author: '李丰绫编',
    intro: '《中国传统节日故事绘本游戏书》收集了除夕、元宵节、清明节、端午节、七夕、中秋节等12个传统节日，每个分册以一个主题的形式展开，以故事为主线，中间穿插传说、神话、诗词与谚语等，解说节日的来历。书中语言简洁明快，情节引人入胜，适合幼儿阅读；大幅精美的图片，色彩鲜艳，造型温馨可爱，让孩子能自己读懂故事的含义；还专门设计了有趣的游戏环节，将迷宫、涂色、拼图、找图、排序、谜语、手工等趣味游戏与故事内容融为一体，增强了阅读的趣味性和娱乐性。',
    url: '/v3/book/detail/NEEUg',
    wUrl: '/book/detail/NEEUg/cover'
  }
]